// 语言包登记表 —— 语言码 → { 导出名, 本地包 }（映射唯一来源）
//
// 放在独立模块而不是 initI18N.js：initI18N 需要引用 remote_lang_pack 触发远程包拉取，
// 而 remote_lang_pack 又需要本地包做兜底合并，写在 initI18N 里会形成循环依赖。
// initI18N 仍会 re-export，外部按原样 `import { LANGUAGE_PACKS } from "@util/initI18N"` 即可。
//
// 新增语言：enum 增加翻译包 + 此处登记 + langConfig 登记
import { PolyglotEnJson, PolyglotZhJson, PolyglotJaJson } from "./enum";

export const LANGUAGE_PACKS = {
  en: { name: "PolyglotEnJson", data: PolyglotEnJson },
  zh: { name: "PolyglotZhJson", data: PolyglotZhJson },
  ja: { name: "PolyglotJaJson", data: PolyglotJaJson },
};

// 语言码 → 本地语言包（远程包未到位时的兜底）
export const getLocalPack = (code) => LANGUAGE_PACKS[code]?.data || null;

// 语言码 → 语言包导出名（后台「导入当前项目配置」生成 export const xxx = {...} 用）
export const getPackExportName = (code) => LANGUAGE_PACKS[code]?.name || "";
